module.exports = __webpack_public_path__ + "img/bar2.c2f0a5ae.jpg";